import { useState } from 'react';

const NONE: ReadonlySet<string> = new Set();

type Opened = {
  locationId: string;
  cartIds: ReadonlySet<string> | null;
};

/**
 * The first carts it sees for a location are the ones the order builder opened with, including
 * when they load after an empty render; switching location starts over.
 */
export function useCartsAddedSinceOpen(
  cartIds: readonly string[],
  locationId: string
): ReadonlySet<string> {
  const [opened, setOpened] = useState<Opened>({ locationId, cartIds: null });
  if (opened.locationId !== locationId) {
    setOpened({ locationId, cartIds: null });
    return NONE;
  }
  if (opened.cartIds === null) {
    if (cartIds.length > 0)
      setOpened({ locationId, cartIds: new Set(cartIds) });
    return NONE;
  }
  const openedWith = opened.cartIds;
  return new Set(cartIds.filter((id) => !openedWith.has(id)));
}
